
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'
import { Image } from 'components/image'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>Die Fakten</h3>
    <p className='fact'>
  Die Hände des Menschen gelten als <b>wichtigster Überträger</b> von Infektionserregern.</p>
    <p className='fact'>
 Wir greifen uns mit den Händen im Durchschnitt bis zu <b>16-mal pro Stunde</b> ins Gesicht. So gelangen die Keime über die Schleimhäute in unseren Körper.
    </p>
    <p className='fact last'>
Durch korrektes Händewaschen lassen sich <b>99,9% der Viren und Bakterien</b> auf den Händen eliminieren.
    </p>
    <p>Trotz diesen Erkenntnissen stellen fast sämtliche Studien fest, dass kaum jemand korrekt die Hände wäscht:</p>
    <ul>
  <li>
  Studentinnen der Fakultät für Angewandte Psychologie der <Link href='https://www.hochschule-heidelberg.de/de/news-detail/news/alarmierend-nur-8-waschen-ihre-haende-in-korrekter-weise/' allowWordWrap mdxType="Link">Hochschule Heidelberg</Link> schauten 1000 WC-Besuchern auf die Finger: Rund 7 Prozent verzichteten gänzlich auf das Händewaschen, 11 Prozent der Männer und 3 Prozent der Frauen. 27 Prozent wuschen ihre Hände nur mit Wasser, und rund 58 Prozent benutzten Wasser und Seife, allerdings nicht mit der erforderlichen Gründlichkeit. Lediglich rund 8 Prozent reinigten ihre Hände vorbildlich. 
  </li>
  <li>
    Eine Studie der <Link href='https://msutoday.msu.edu/_/pdf/assets/2013/hand-washing-study.pdf' allowWordWrap mdxType="Link">US-Universität Michigan</Link> kam zu ähnlichen Ergebnissen: Nur fünf Prozent der Menschen waschen ihre Hände richtig. 3749 Personen wurden auf öffentlichen Toiletten 
    beobachtet. Jeder Zehnte wusch seine Hände gar nicht, ungefähr ein Drittel verwendete keine Seife. Auch hier: Besonders Männer sind nachlässig beim Händewaschen. 
    Rund 15 Prozent der Männer wuschen sich die Hände gar nicht, bei den Frauen waren es nur 7 Prozent. Der Handkontakt mit Männern birgt also ein höheres Übertragungsrisiko. 
      </li>
  <li>Eine andere Studie wurde vom US-Ministerium für Landwirtschaft in Zusammenarbeit mit der North Carolina State University durchgeführt. Kameras dokumentierten, wie 383 Testpersonen zwei Mahlzeiten zubereiteten. Viele wuschen sich dabei die Hände, doch es zeigte sich: Sie taten es falsch. Schockierenderweise verwendeten ganze 24 Prozent keine Seife. Und kaum jemand hatte die Hände mindestens zwanzig Sekunden mit Seife eingeschäumt.</li>
  <li>Auch das Unwissen über die Wichtigkeit des Händewaschens ist gross: Die deutsche Bundeszentrale für gesundheitliche Aufklärung (BZgA) hat 2012 zum Thema Hygieneverhalten in der Bevölkerung eine Telefonumfrage durchführen lassen. Nur knapp die Hälfte der rund 4500 befragten Personen hielt es für wahrscheinlich, dass man sich über die eigenen Hände mit Krankheiten anstecken kann.</li>
  <li>
         Eine <Link href='https://onlinelibrary.wiley.com/doi/full/10.1111/risa.13438' allowWordWrap mdxType="Link">ganz aktuelle Studie</Link> kommt zum Schluss: Händewaschen am Flughafen kann Epidemien verhindern. Im Durchschnitt haben nur etwa 20 Prozent der Menschen an Flughäfen saubere Hände. «Die anderen 80 Prozent verunreinigen mit Viren und Bakterien potenziell alles, was sie berühren», sagt Studienautor Christos Nicolaides. Würden 60 Prozent der Reisenden zu jedem Zeitpunkt saubere Hände haben, könnte dies die weltweite Verbreitung von Krankheiten um fast 70 Prozent verlangsamen, stellen die Forscher fest.
     </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;